<template>
    <div class="Astudy safe-distance-top">
        <div class="Astudy_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">研究方向</div>
            <div class="determine" @click="ondetermine">确定</div>
        </div>
        <div class="Astudy_bottm">
            <van-cell-group inset>
                <van-field
                    style="height: 48px; padding: 10px 0px"
                    center
                    v-model="subInfo.userInfo.researchDirection"
                    label="研究方向"
                    placeholder="请输入"
                    maxlength="50"
                >
                    <template #button>
                        <van-button size="small" style="border: none"
                            >{{ subInfo.userInfo.researchDirection.length }}/50</van-button
                        >
                    </template></van-field
                >
            </van-cell-group>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "Astudy",
    data() {
        return {
            disabled: false,
            subInfo: {
                userInfo: {
                    researchDirection: "",
                },
            },
        };
    },
    created() {
        if (JSON.parse(sessionStorage.getItem("subInfo")).userInfo) {
            this.subInfo = JSON.parse(sessionStorage.getItem("subInfo"));
        }
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        // 点击确定
        ondetermine() {
            if (this.subInfo.userInfo.researchDirection == "") {
                Toast("不能为空");
            } else {
                sessionStorage.setItem("subInfo", JSON.stringify(this.subInfo));
                window.history.go(-1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.Astudy {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .Astudy_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .Astudy_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }
}
</style>
